import styled from 'styled-components';
import { colors, screens } from '../../styles';

export const Form = styled.div`
  padding: 32px 12px 12px 0;
  background: ${colors.white};
  border-radius: 6px;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`;

export const TitleText = styled.div`
  padding-left: 32px;
  font-size: 24px;
  font-weight: bold;
`;

export const ButtonS = styled.div`
  background-color: ${colors.primary};
  border-radius: 6px;
  cursor: pointer;
  & > p {
    font-size: 12px;
    color: ${colors.white};
    padding: 12px 16px;
  }
`;

export const ExportButton = styled.div`
  display: block;
  margin-left: 40px;

  @media (max-width: ${screens.screen_xs_max}) {
    display: none;
  }
`;

export const EditButton = styled.div`
  display: block;
  margin-left: 12px;

  @media (max-width: ${screens.screen_xs_max}) {
    display: none;
  }
`;

export const DeleteButton = styled.div`
  display: block;
  margin-left: 12px;

  @media (max-width: ${screens.screen_xs_max}) {
    display: none;
  }
`;

export const MobileButtons = styled.div`
  display: none;

  @media (max-width: ${screens.screen_xs_max}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
  }
`;

export const MobileButton = styled.div`
  margin-left: 12px;
`;

export const FieldContainer = styled.div`
  margin: 0 0 16px 32px;
`;

export const FieldTitle = styled.div`
  color: ${colors.history_gray};
  margin-bottom: 6px;
  font-size: 16px;
`;

export const FieldValue = styled.div`
  font-size: 18px;
  font-weight: 400;
`;
